var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineEmptyWalletChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.26 22.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h5.48c1.66 0 3.01-1.35 3.01-3.01v-.44H19.6c-1.51 0-2.79-1.12-2.91-2.56-.08-.83.22-1.64.82-2.23.51-.52 1.21-.81 1.96-.81h1.27v-.69c0-1.66-1.35-3.01-3.01-3.01H6.25c-1.66 0-3.01 1.35-3.01 3.01v1.73c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-1.73C1.74 9.02 3.76 7 6.25 7h11.48c2.49 0 4.51 2.02 4.51 4.51v1.44c0 .41-.34.75-.75.75h-2.02c-.35 0-.67.13-.9.37-.29.28-.43.66-.39 1.04.06.66.69 1.19 1.41 1.19h1.9c.41 0 .75.34.75.75v1.19a4.496 4.496 0 0 1-4.5 4.51h-5.48z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75 12.41V7.84c0-1.49.94-2.84 2.33-3.37l7.94-3c.82-.31 1.73-.2 2.44.3.72.5 1.14 1.31 1.14 2.18v3.8c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-3.8c0-.38-.18-.73-.5-.95-.32-.22-.7-.27-1.06-.13l-7.94 3c-.81.31-1.36 1.1-1.36 1.97v4.57c.01.42-.33.75-.74.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.69 15.24c-.08-.83.22-1.64.82-2.23.51-.52 1.21-.81 1.96-.81h2.08c.99.03 1.75.81 1.75 1.77v2.06c0 .96-.76 1.74-1.72 1.77H19.6c-1.51 0-2.79-1.12-2.91-2.56zm2.79-1.54c-.35 0-.67.13-.9.37-.29.28-.43.66-.39 1.04.06.66.69 1.19 1.41 1.19h1.96c.13 0 .25-.12.25-.27v-2.06c0-.15-.12-.26-.28-.27h-2.05z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h7c.41 0 .75.34.75.75s-.34.75-.75.75H7zM8.75 18.94v-1.28c0-.22-.18-.41-.41-.41H3c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h5.34c1.05 0 1.91.86 1.91 1.91v1.28c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.69 18.25-1.22-1.22a.755.755 0 0 1 0-1.06l1.22-1.22c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-.69.69.69.69c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22zM4.16 22.53c-1.05 0-1.91-.86-1.91-1.91v-1.28c0-.41.34-.75.75-.75s.75.34.75.75v1.28c0 .22.18.41.41.41H9.5c.41 0 .75.34.75.75s-.34.75-.75.75H4.16z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75 23.53a.755.755 0 0 1 0-1.06l.69-.69-.69-.69a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l1.22 1.22c.29.29.29.77 0 1.06l-1.22 1.22c-.14.15-.34.22-.53.22s-.38-.07-.53-.22z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineEmptyWalletChange);
export default __webpack_public_path__ + "static/media/vuesax-outline-empty-wallet-change.ccb56112d2fafddbc5a408af447120fd.svg";
export { ForwardRef as ReactComponent };